import * as React from "react";
import useSendTelemetry from "logic/telemetry/useSendTelemetry";
import { TELEMETRY_EVENT_TYPE } from "telemetry/Constants";
import { useModalContext } from "common/contexts";
import { CurrentUserStore } from "stores/users/CurrentUserStore";
import useCurrentUser from "hooks/useCurrentUser";
import GitRulesModal from "./GitRules";
import SigmaModal from "./SigmaModal";
import UploadRulesModal from "./UploadRulesModal";
function SigmaModals() {
  const sendTelemetry = useSendTelemetry();
  const currentUser = useCurrentUser();
  const { modal, setModal, entity: sigmaRule, setEntity } = useModalContext();
  if (modal) {
    sendTelemetry(TELEMETRY_EVENT_TYPE.SECURITY_APP.SIGMA_IMPORT_RULES_OPENED, {
      app_pathname: "security",
      app_section: "sigma",
      event_details: { action: modal }
    });
  }
  const onClose = () => {
    CurrentUserStore.update(currentUser.username);
    setEntity(null);
    setModal(null);
  };
  switch (modal) {
    case "MANUAL-ADD":
      return /* @__PURE__ */ React.createElement(SigmaModal, { rule: sigmaRule, onConfirm: onClose, onCancel: onClose });
    case "IMPORT-FROM-GIT":
      return /* @__PURE__ */ React.createElement(GitRulesModal, { onClose });
    case "UPLOAD-RULES":
      return /* @__PURE__ */ React.createElement(UploadRulesModal, { onClose });
    default:
      return null;
  }
}
export default SigmaModals;
